import React from "react";
import "./PlaceOrderButton.css";
import {cx} from "../../lib/ClassSet";

const NO_OP = (e) => e.preventDefault();

const PlaceOrderButton = (props) => {

  let classes = cx({
    "PlaceOrderButton": true,
    "u-active": props.active
  })

  let clickFn = props.active ? props.onClick : NO_OP;

  return (
    <div className={classes} onClick={clickFn}>
      <div className="label">{props.label}</div>
    </div>
  )

}

PlaceOrderButton.defaultProps = {
  label: "Place Order",
  active: true
}

export default PlaceOrderButton;